import { Route } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/sun_capital/master-plane/U Green/E-1BD/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/sun_capital/master-plane/U Green/E-1BD/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/sun_capital/master-plane/U Green/E-1BD/payment/PaymentPage';

const Index = () => {
  return (
    <>
      <Route exact path={`/sun_capital/master-plan/u-green/E-1BD/plan`}>
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/u-green/E-1BD/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/u-green/E-1BD/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
